








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloCours, AloCours } from '@/models/alo/AloCours';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'EditBaseCours',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseCours extends Vue {
  
  private original:AloCours = getDefaultAloCours()
  private modified:AloCours = getDefaultAloCours()
  private showDrawer = false
  private saving = false
    
  edit(item:AloCours) {
    this.$store.myActions.ADM_COURS_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloCours(),...item}    
    this.modified = cloneDeep(this.original)
    
    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get coursStatus() {
    return this.$store.myGetters.coursStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_COURS_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.coursStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
